module.exports = __webpack_public_path__ + "img/3C.093fe615.png";